import { useRequiredContext } from "@redotech/react-util/context";
import { useHasPermission } from "@redotech/redo-merchant-app-common/auth/permissions-context";
import { MerchantRoutesContext } from "@redotech/redo-merchant-app-common/merchant-routes";
import { TeamContext } from "@redotech/redo-merchant-app-common/team";
import { SupportPermissions } from "@redotech/redo-model/permissions";
import { RedoSecondaryNavItem } from "@redotech/redo-web/arbiter-components/navigation/secondary/redo-secondary-nav-item";
import BarChart10FilledIcon from "@redotech/redo-web/icon-old/bar-chart-10-filled.svg";
import BarChart10Icon from "@redotech/redo-web/icon-old/bar-chart-10.svg";
import { memo } from "react";
import { useMatch } from "react-router-dom";
import { SupportSuiteStatusesContext } from "../../../../redo-suite/support-cloud";

export const SupportAnalyticsItems = memo(function SupportAnalyticsItems() {
  const routes = useRequiredContext(MerchantRoutesContext);
  const team = useRequiredContext(TeamContext);
  const { supportEnabled } = useRequiredContext(SupportSuiteStatusesContext);

  const canViewSupportAnalytics = useHasPermission(
    SupportPermissions.VIEW_ANALYTICS,
  );
  const showSupportAnalytics = supportEnabled && canViewSupportAnalytics;

  const aiEnabled = !!team?.settings.support?.ai?.enabled;

  const analyticsRoute = routes.legacySupportBaseUrl + "/analytics";
  const legacyAiDashboardRoute = routes.legacySupportBaseUrl + "/dashboard";
  const aiDashboardRoute = routes.supportBaseUrl + "/dashboard";
  const analyticsRouteMatch = useMatch(`${analyticsRoute}/*`);
  const legacyAiDashboardRouteMatch = useMatch(`${legacyAiDashboardRoute}/*`);
  const aiDashboardRouteMatch = useMatch(`${aiDashboardRoute}/*`);
  const anyChildSelected =
    analyticsRouteMatch || legacyAiDashboardRouteMatch || aiDashboardRouteMatch;

  const showAiDashboard = aiEnabled;

  const shouldRenderAnalytics = showSupportAnalytics || showAiDashboard;

  if (!shouldRenderAnalytics) {
    return null;
  }

  return (
    <RedoSecondaryNavItem
      action={{ type: "link", href: aiDashboardRoute }}
      anyChildSelected={!!anyChildSelected}
      FilledIcon={BarChart10FilledIcon}
      friendlyName="Dashboard"
      id="support-analytics"
      UnfilledIcon={BarChart10Icon}
    />
  );
});
